import svgLoader from '../../util/svgLoader';
import getNextFocusEle from '../../util/getNextFocusElement';
const { text, url } = window;

export default class NotificationDrawer extends Backbone.View {
    constructor() {
        super(...arguments);
        this.$triggerEl = $('.js-notificationsButton');
        this.isOpen = false;
        this.bus = window.globalEvents;
        this.isMobile = false;

        this.renderShell();
        this.bus.on('title:borrow:success', () =>
            setTimeout(() => this.loadNotifications(), 500)
        );
        this.loadNotifications();

        this.$el.on('click', (e) => {
            // clicks inside the container are trapped so they can't trigger the close handler.
            e.stopPropagation();
        });

        $('body').on('click', (e) => this.tryClose(e));
        this.$triggerEl.on('click keydown', (e) => this.toggle(e));

        this.$el.on('keydown', (e) => {
            if (e.key === 'Escape') {
                this.tryClose(e);
            } else if (e.key === 'Tab') {
                if (
                    $('.NotificationsContainer').find('a').length === 0 ||
                    $('.NotificationsContainer a').is(document.activeElement) ||
                    (e.shiftKey &&
                        $('.NotificationsContainer')
                            .children()
                            .first()
                            .is(document.activeElement))
                ) {
                    this.tryClose(e);
                }
            }
        });
    }

    setFocus(e) {
        const visibleTriggerEle = this.$triggerEl.filter(
            this.isMobile ? '.mobile' : '.desktop'
        );
        if (!this.isOpen) {
            if (e.key === 'Escape' || (e.key === 'Tab' && e.shiftKey)) {
                visibleTriggerEle.focus();
            } else {
                const nextFocusEle = getNextFocusEle(
                    visibleTriggerEle,
                    $('.Notifications-Dropdown').find('*')
                );
                nextFocusEle.focus();
            }
        }
    }

    close() {
        this.$el.detach();
        this.isOpen = false;
    }

    tryClose(e) {
        if (this.isOpen && e && !e.originalEvent.isDrawerOpenClick) {
            e.preventDefault();
            this.close();
            this.$triggerEl.attr('aria-expanded', 'false');
            this.setFocus(e);
        }
    }

    open(e) {
        if (!this.isOpen) {
            window.Foundation.libs.dropdown.closeall();
            this.isMobile = $(e.currentTarget).hasClass('mobile');
            e.originalEvent.isDrawerOpenClick = true;
            // There are two potential click targets: one for the mobile nav and one for the desktop nav
            $(e.currentTarget)
                .siblings('.Notifications-Dropdown')
                .append(this.$el);
            this.isOpen = true;
            $('.icon-notification').removeClass('ring');
            this.$triggerEl.attr('aria-expanded', 'true');
            svgLoader();

            this.$el.find(':focusable:visible').first().focus();
        }
    }

    toggle(e) {
        if (!this.isSelectEvent(e)) {
            return;
        }
        e.stopPropagation();
        if (this.isOpen) {
            this.tryClose(e);
        } else {
            this.open(e);
        }
    }

    startSpinner(target) {
        target.append(this.$spinner);
    }

    stopSpinner() {
        this.$spinner.detach();
    }

    startNagging(resultCount) {
        $('.notificationDotContainer').css('display', 'block');
        $('.notificationDotContainer.mobile').css('display', 'inline-block');
        $('.icon-notification').addClass('ring');

        const activeNotificationText = text(
            'notifications.activeNotificationsLabel',
            {
                num: resultCount,
            }
        );
        $('.notificationAlert').text(activeNotificationText);
        $('.js-notificationsButton').attr('aria-label', activeNotificationText);
    }

    clearNotificationIcon() {
        $('.notificationDotContainer').css('display', 'none');
        $('.notificationDotContainer.mobile').css('display', 'none');
        $('.icon-notification').removeClass('ring');
        $('.js-notificationsButton').attr(
            'aria-label',
            text('notifications.notificationsLabel')
        );
        $('.notificationAlert').empty();
    }

    renderShell() {
        this.$el.empty();
        this.$el.append(`<div class='NotificationsCaret white'></div>
                        <div class="NotificationsContainer" role="dialog" aria-labelledby="hold-header">
                            <div class="spinnerBox">
                                <div class='SpinnerContainer'>
                                    <div class='spinner'></div>
                                </div>
                            </div>
                        </div>`);
        this.$spinner = this.$el.find('.spinnerBox');
        this.$mainContainer = this.$el.find('.NotificationsContainer');
        this.$caret = this.$el.find('.NotificationsCaret');
    }

    loadNotifications() {
        this.getHolds()
            .then((response) => {
                this.stopSpinner();
                this.renderNotifications(response);
            })
            .catch((error) => {
                this.stopSpinner();
                window.Logger.log('error', 'Failed to show notifications', {
                    message: error.statusText || error,
                });
                this.$mainContainer.empty().append(
                    $(`<div class='No-Notifications' tabindex='-1'>
                                <div class='No-NotificationTextContainer'>
                                    <p>${text('notifications.fetchingError', {
                                        link: this.getContactSupportLink(),
                                    })}</p>
                                </div>
                        </div>`)
                );
            });
    }

    getHolds() {
        return new Promise((resolve, reject) =>
            $.ajax({
                method: 'GET',
                url: window.url(window.routes.rest.holds.available),
                timeout: 10000,
            })
                .done((response) => {
                    resolve(response);
                })
                .fail((xhr, status, err) => reject(err))
        );
    }

    renderNotifications({ holdsAvailable, holdsExpiring, holdsAutoSuspended }) {
        const numHoldActions =
            holdsAvailable + holdsExpiring + holdsAutoSuspended;
        if (numHoldActions > 0) {
            if (numHoldActions >= 2) {
                this.holdActionMessage('multipleHoldActions');
            } else if (holdsAvailable) {
                this.holdActionMessage('holdReady');
            } else if (holdsExpiring) {
                this.holdActionMessage('holdExpiring');
            } else if (holdsAutoSuspended) {
                this.holdActionMessage('holdAutoSuspended');
            }
        } else if (holdsAvailable) {
            this.holdActionMessage('holdReady');
        } else {
            this.noNotificationsMessage();
            this.clearNotificationIcon();
        }
    }

    noNotificationsMessage() {
        this.$mainContainer.empty()
            .append(`<div class='No-Notifications' tabindex='-1'>
                        <div class='No-NotificationImageContainer svg dynamic-loader' data-src='notifications-empty.svg'></div>
                        <div class='No-NotificationTextContainer'>
                            <h2 class='No-Notifications-Header' id='hold-header'>${text(
                                'notifications.noNotifications.header'
                            )}</h2>
                            <p>${text('notifications.noNotifications.body')}</p>
                        </div>
                        </div>`);
    }

    holdActionMessage(holdAction) {
        const holdsLink = url(window.routes.accountHolds);
        this.$mainContainer.empty()
            .append(`<div class='Hold-Notification-Dropdown' tabindex='-1'>
                        <h2 class='Hold-Header' id='hold-header'>${text(
                            `notifications.${holdAction}.header`
                        )}</h2>
                        <p>${text(`notifications.${holdAction}.body`, {
                            link: `<a href=${holdsLink}>${text('holds')}</a>`,
                        })}</p>
                    </div>`);
        this.startNagging(1);
    }

    getContactSupportLink() {
        let link = '';
        if (window.OverDrive.librarySupportUrl !== '') {
            link = window.OverDrive.librarySupportUrl;
        } else if (window.OverDrive.librarySupportEmail !== '') {
            link = window.OverDrive.librarySupportEmail;
        } else {
            link = url(window.routes.supportMembers);
        }
        return `<a class='primary-color' href='${link}' target='_blank' rel='noreferrer'>${text(
            'contactSupport'
        ).toLowerCase()}</a>`;
    }

    isSelectEvent(e) {
        if (e.type === 'click' || e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            return true;
        }
        return false;
    }
}
